import React, { SVGAttributes } from 'react';

const IconLockUnlocked: React.FC<SVGAttributes<SVGElement>> = ({ ...props }) => (
  <svg viewBox="0 0 12 12" fill="#767676" {...props}>
    <path d="M7.887 2c1.694 0 2.576 1.122 2.576 2.623 0 .291-.247.527-.552.527-.305 0-.552-.236-.552-.527 0-.974-.467-1.57-1.472-1.57-.96 0-1.43.545-1.469 1.445l-.002.125v1.001c0 .291-.248.527-.552.527-.28 0-.51-.198-.547-.455l-.005-.072v-1C5.312 3.121 6.194 2 7.887 2z" />
    <path d="M2 5.94c0-.415.336-.75.75-.75h4.387c.415 0 .75.335.75.75v3.417c0 .414-.335.75-.75.75H2.75c-.414 0-.75-.336-.75-.75V5.94z" />
  </svg>
);

export default IconLockUnlocked;
